<template>
  <div class="container page">
    <van-nav-bar :title="hasPayPassword ? $t('setting.change_money_pwd') : $t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
        <!-- 修改密码模式：显示旧密码输入框 -->
        <div class="item" v-if="hasPayPassword">
            <p class="title">{{$t("setting.old_money_pwd")}}</p>
            <van-password-input
                :value="oldpw"
                :length="6"
                :gutter="10"
                :focused="oldshowKeyboard"
                @focus="oldshowKeyboard = true;newshowKeyboard = false;confirmshowKeyboard = false;"
            />
            <van-number-keyboard
                v-model="oldpw"
                :show="oldshowKeyboard"
                @input ="oldpw.length !== 5 ? oldshowKeyboard = true  : newshowKeyboard=true;"
                @blur="oldshowKeyboard = false"
            />
        </div>

        <!-- 新密码输入框 -->
        <div class="item">
            <p class="title">{{hasPayPassword ? $t("setting.new_money_pwd") : $t("setting.money_place")}}</p>
            <van-password-input
                :value="newpw"
                :length="6"
                :gutter="10"
                :focused="newshowKeyboard"
                @focus="newshowKeyboard = true;oldshowKeyboard = false;confirmshowKeyboard = false;"
            />
            <van-number-keyboard
                v-model="newpw"
                :show="newshowKeyboard"
                @input ="newpw.length !== 5 ? newshowKeyboard = true  : confirmshowKeyboard=true;"
                @blur="newshowKeyboard = false"
            />
        </div>

        <!-- 确认新密码输入框 -->
        <div class="item">
        <p class="title">{{$t("setting.money_again_place")}}</p>
        <van-password-input
            :value="confirmpw"
            :length="6"
            :gutter="10"
            :focused="confirmshowKeyboard"
            @focus="confirmshowKeyboard = true;oldshowKeyboard=false;newshowKeyboard=false;"
        />
        <van-number-keyboard
            v-model="confirmpw"
            :show="confirmshowKeyboard"
            @input ="confirmpw.length !== 5 ? confirmshowKeyboard = true  : confirmshowKeyboard = false;oldshowKeyboard=false;newshowKeyboard=false"
            @blur="confirmshowKeyboard = false"
        />
      </div>
        <van-button class="sub-btn" type="default" @click="setPayPassword()">{{$t("reservation.submit")}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      oldpw: '',
      newpw: '',
      confirmpw: '',
      oldshowKeyboard: false,
      newshowKeyboard: true,
      confirmshowKeyboard: false,
      userInfo: {},
      hasPayPassword: false // 是否已设置过提现密码
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    setPayPassword() {
      // 关闭所有键盘
      this.oldshowKeyboard = false;
      this.newshowKeyboard = false;
      this.confirmshowKeyboard = false;

      // 如果已设置过密码，需要验证旧密码
      if(this.hasPayPassword){
        if(this.oldpw.length !== 6){
          this.oldshowKeyboard = true;
          this.$toast(this.$t("setting.old_pwd_required"));
          return false;
        }
      }

      // 验证新密码长度
      if(this.newpw.length !== 6){
        this.newshowKeyboard = true;
        this.$toast(this.$t("setting.pwd_6_digits"));
        return false;
      }

      // 验证确认密码长度
      if(this.confirmpw.length !== 6){
        this.confirmshowKeyboard = true;
        this.$toast(this.$t("setting.pwd_6_digits"));
        return false;
      }

      // 验证两次新密码是否一致
      if(this.newpw !== this.confirmpw){
        this.$toast(this.$t("setting.pwd_not_match"));
        return false;
      }

      // 验证密码是否为纯数字
      if(!/^\d{6}$/.test(this.newpw)){
        this.$toast(this.$t("setting.pwd_must_digits"));
        return false;
      }

      // 提交数据
      const requestData = this.hasPayPassword
        ? { old_paypassword: this.oldpw, paypassword: this.newpw }
        : { paypassword: this.newpw };

      this.$http({
        method: 'post',
        data: requestData,
        url: 'user_set_paypw'
      }).then(res=>{
        if(res.code === 200){
          setTimeout(() => {
            this.$toast(res.msg);
          }, 500);
          this.$router.push("Mine")
        }else if(res.code === 401){
          this.$toast(res.msg);
        }else {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          // 判断用户是否已设置提现密码
          // 假设后端返回 is_set_paypw 字段，或者 paypassword 不为空
          this.hasPayPassword = res.data.is_set_paypw === 1 || (res.data.paypassword && res.data.paypassword !== '');

          // 如果已设置密码，第一个键盘应该是旧密码键盘
          if(this.hasPayPassword){
            this.oldshowKeyboard = true;
            this.newshowKeyboard = false;
          }
        }else if(res.code === 401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .wrapper{
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}
.container .wrapper .item .title{
  margin: 40px 0;
  line-height: 20px;
  font-size: 30px;
  font-weight: 500;
  color: #000;
  text-align: center;
}
::v-deep .van-password-input{
  width: 80%;
  height: 150px;
  margin: 0 auto;

}
::v-deep .van-password-input__security li {
  font-size: 30px;
  line-height: 30;
  background-color: #ebedf0;
}
::v-deep .van-password-input__security {
  height: 130px;
}
::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 30px;
}
.van-password-input__security i {
  width: 25px;
  height: 25px;
}
::v-deep .van-key {
  height: 100px;
  font-size: 55px;
  line-height: 20px;
  border-radius: 20px;
}
::v-deep .van-number-keyboard {
  z-index:100;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f2f3f5;
}
::v-deep .van-key__collapse-icon {
   width: 50px;
   height: 50px;
 }
::v-deep .van-key__delete-icon {
  width: 50px;
  height: 50px;
}
.container .wrapper .sub-btn{
  margin: 110px 0 0 10%;
  height: 100px;
  width: 80%;
  font-size: 35px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
}
</style>
